import { render, staticRenderFns } from "./LoginPage.vue?vue&type=template&id=02bb2cb8&scoped=true&"
import script from "./LoginPage.vue?vue&type=script&lang=ts&"
export * from "./LoginPage.vue?vue&type=script&lang=ts&"
import style0 from "./LoginPage.vue?vue&type=style&index=0&id=02bb2cb8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02bb2cb8",
  null
  
)

export default component.exports
import QPage from 'quasar/src/components/page/QPage.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QPage});
